var config = function (C) {
  C.APP_NAME = "retailer";
  C.userUrl = "/api/retailer/user";

  C.roles = [
    { id: "group_director", label: "Group Director" },
    { id: "retailer_admin", label: "Admin" },
    { id: "retailer", label: "Manager" },
    { id: "retailer_employee", label: "Employee" },
  ];

  C.containerTypes = [
    { type: "bottle", label: "Bottles" },
    { type: "can", label: "Cans" },
    { type: "keg", label: "Kegs" },
    { type: "other", label: "Other" },
  ];
  C.daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  C.nonDeliveryDistributors = ["Burke Bev"];
  C.MAX_DISTRIBUTORS_IN_SIDEBAR = 4;
  C.CREDIT_CARD_CAP = 1000;
  window.C = C;
};

config.$inject = ["C"];

if (typeof tiz !== "undefined" && tiz.config) {
  tiz.config(config);
}

export default config;
